/* ==========================================================================
   Kids Arena: mobiele menu-drawer sluiten bij een ankerlink

   Dawn sluit de drawer pas wanneer de pagina opnieuw laadt. Menu-items die
   naar een sectie op dezelfde pagina wijzen, zoals /#inside en /#faq, geven
   geen paginawissel, dus de drawer bleef openstaan terwijl de pagina eronder
   naar de sectie sprong.

   Let op bij het aanroepen van Dawn's eigen sluitfunctie: HeaderDrawer
   overschrijft closeMenuDrawer van MenuDrawer en begint met

       if (!elementToFocus) return;

   De bovenliggende klasse heeft genoeg aan alleen het event, maar deze eist
   een tweede argument en doet anders helemaal niets. Daarom geven we altijd
   de summary mee, het hamburgerknopje. Dat is ook waar de focus hoort te
   landen als het menu dichtgaat, en omdat de header sticky is staat dat
   knopje al in beeld, dus de pagina springt er niet naartoe.
   ========================================================================== */

(function () {
  /* De grijze waas over de pagina hoort bij dit stukje uit base.css:

         .header__icon--menu[aria-expanded=true]::before { ...
           background: rgba(var(--color-foreground), .5); }

     Die laag hangt dus aan aria-expanded op het hamburgerknopje, niet aan het
     geopende menu. Dawn zet dat attribuut alleen terug bij een toetsenbord-
     event:

         if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);

     Bij een tik of klik blijft het op true staan en blijft de laag liggen.
     Daarom zetten we hem hier zelf terug. */
  function resetExpanded(summary) {
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeDrawer(drawer, event) {
    var summary = drawer.querySelector('summary.header__icon--menu') || drawer.querySelector('summary');

    if (typeof drawer.closeMenuDrawer === 'function' && summary) {
      drawer.closeMenuDrawer(event, summary);
      resetExpanded(summary);
      return;
    }

    // Valt Dawn ooit om, dan sluiten we hem alsnog met de hand.
    var details = drawer.querySelector('details.menu-drawer-container');
    if (!details) return;
    details.classList.remove('menu-opening');
    details.querySelectorAll('details').forEach(function (inner) {
      inner.removeAttribute('open');
      inner.classList.remove('menu-opening');
    });
    details.removeAttribute('open');
    document.body.className = document.body.className.replace(/\boverflow-hidden-\S+/g, '').trim();
    resetExpanded(summary);
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a.menu-drawer__menu-item');
      if (!link) return;

      // Ouder-items met een submenu zijn <summary>, geen <a>, dus een submenu
      // uitklappen sluit de drawer niet per ongeluk.
      var drawer = link.closest('header-drawer');
      if (!drawer) return;

      // Ook sluiten bij een echte navigatie kan geen kwaad: dan is de pagina
      // toch al weg. Zo hoeft de code niet te gokken of een href een anker is.
      closeDrawer(drawer, event);
    },
    true // capture, zodat een stopPropagation onderweg dit niet kan blokkeren
  );
})();
